import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaSignOutAlt, FaCog, FaBox, FaClipboardList, FaHome, FaCogs } from 'react-icons/fa';

const AdminLayout = ({ children }) => {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const isActive = (path) => location.pathname === path;

  // Redirect if not admin
  if (!isAdmin) {
    navigate('/admin/login');
    return null;
  }

  return (
    <div className="App">
      {/* Admin Navbar */}
      <nav className="navbar bg-dark text-white" style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.15)' }}>
        <div className="container d-flex justify-content-between align-items-center">
          <Link to="/admin/dashboard" className="navbar-brand text-white">
            <FaCog className="me-2" />
            Admin Panel
          </Link>
          
          <ul className="navbar-nav d-flex align-items-center">
            <li>
              <Link to="/admin/dashboard" className={`nav-link text-white${isActive('/admin/dashboard') ? ' bg-primary' : ''}`}>
                <FaHome className="me-1" />
                Dashboard
              </Link>
            </li>
            <li>
              <Link to="/admin/products" className={`nav-link text-white${isActive('/admin/products') ? ' bg-primary' : ''}`}>
                <FaBox className="me-1" />
                Products
              </Link>
            </li>
            <li>
              <Link to="/admin/orders" className={`nav-link text-white${isActive('/admin/orders') ? ' bg-primary' : ''}`}>
                <FaClipboardList className="me-1" />
                Orders
              </Link>
            </li>
            <li>
              <Link to="/admin/settings" className={`nav-link text-white${isActive('/admin/settings') ? ' bg-primary' : ''}`}>
                <FaCogs className="me-1" />
                Settings
              </Link>
            </li>
            <li>
              <div className="nav-link text-white d-flex align-items-center" style={{ fontWeight: 600 }}>
                <FaCog className="me-1" />
                {user?.name || 'Admin'}
              </div>
            </li>
            <li>
              <button onClick={handleLogout} className="btn btn-danger btn-sm nav-link d-flex align-items-center gap-2" style={{ marginLeft: 8 }}>
                <FaSignOutAlt />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout; 